import { BaseManager } from "../base/BaseManager";
import { Context } from "../core/context";
import * as THREE from "three";
/**
 * 材质管理，主要用于加载过程中创建材质，材质合并，避免材质过多造成内存膨胀
 */
export class MaterialManager extends BaseManager {
  items: {
    [key: string]: THREE.Material;
  } = {};
  constructor(context: Context) {
    super(context);
    this.items = {};
  }
  has(key: string): boolean {
    return this.items.hasOwnProperty(key);
  }
  set(key: string, val: THREE.Material) {
    // @ts-ignore
    this.items[key] = val;
  }
  delete(key: string): boolean {
    if (this.has(key)) {
      // @ts-ignore
      delete this.items[key];
    }
    return false;
  }
  get(key: string): THREE.Material {
    // @ts-ignore
    return this.items[key];
  }
  values(): THREE.Material[] {
    let values: THREE.Material[] = [];
    for (let k in this.items) {
      if (this.has(k)) {
        // @ts-ignore
        values.push(this.items[k]);
      }
    }
    return values;
  }

  createLineMaterial(color: THREE.Color, lineStyle?: string) {
    let key = color.getHexString() + "line";
    if (!this.items[key]) {
      this.items[key] = new THREE.LineBasicMaterial({
        color: color,
        side: THREE.DoubleSide,
      });
    }
    return this.items[key] as THREE.LineBasicMaterial;
  }

  createDashedLineMaterial(color: THREE.Color, lineStyle?: string) {
    let key = color.getHexString() + "dashed";
    if (!this.items[key]) {
      this.items[key] = new THREE.LineDashedMaterial({
        color: new THREE.Color(color),
        side: THREE.DoubleSide,
        linewidth: 1,
        dashSize: 0.25, //虚线的大小
        gapSize: 0.1, //虚线之间的间隔大小
      });
    }
    return this.items[key] as THREE.LineDashedMaterial;
  }
  createMeshBasicMaterial(color: THREE.Color) {
    let key = color.getHexString() + "mesh";
    if (!this.items[key]) {
      this.items[key] = new THREE.MeshBasicMaterial({
        color: color,
        side: THREE.DoubleSide,
      });
    }
    return this.items[key] as THREE.MeshBasicMaterial;
  }
}
